export const AppRoutes = {
	Dashboard: 'dashboard',

	// subscribers

	Subscribers: 'subscribers',
	SubInvestor: 'investors',
	SubBorrowers: 'borrowers',

	//investor
	Investor: 'investors',
	IAll: 'all',
	Incomplete: 'incomplete',
	Onboarding: 'onboarding',
	Todo: 'to-do',
	Updated: 'updated',
	FollowUp: "follow-up",
	Icompliance: 'compliance',
	Iapproved: 'approved',
	Iblocked: 'blocked',
	Iwinddown: 'winddown',
	Iarchived: 'archived',
	Irejected: 'rejected',

	//borrower
	BAll: 'all',
	Borrowers: 'borrowers',
	BIncomplete: 'incomplete',
	BOnboarding: 'onboarding',
	Bcompliance: 'compliance',
	Bapproved: 'approved',
	Barchived: 'archived',

	// loans
	LAll: 'all',
	Loans: 'loans',
	Lpending: 'pending-loans',
	Lcredit: 'credit-analysis',
	lpreCompliance: 'pre-compliance',
	Lcompliance: 'compliance-loan',
	Lprefundrasing: 'pre-fundraising',
	Lfundraising: 'fundraising',
	LfullyFilled: 'fully-filled',
	Lprelaunch: 'pre-launch',
	Lcancelled: 'cancelled',
	Lmonitor: 'monitor',
	Llate: 'late',
	Lrestructured: 'restructured',
	Lrejected: 'rejected',
	Ldefault: 'default',
	LfullyPaid: 'fully-paid',
	Lcollections: 'collections',

	//transactions

	Transactions: 'transactions',

	// admin users

	AdminUsers: 'admin-users',

	// members

	Members: 'members',

	// announcementBar

	AnnouncementBar: 'announcement-bar',

	// Notifications

	Notification: 'notifications',

	//Push Notification
	PushNotification: 'push-notifications',

	//sms Notification
	SMSNotification: 'sms-notification',

	// Static Page

	StaticPages: 'static-pages',

	//Blog

	Blog: 'blog',
	BlogCategory: 'category',
	BlogArticle: 'article',

	//comparison
	CompetitorsComparisons: 'reviews',

	// FAQ

	// Promotional Code
	PromotionalCode: 'promo-code',

	FAQ: 'faq',
	FAQCategory: 'category',
	FAQQuestions: 'questions',

	//Control panel

	ControlPanel: 'control-panel',

	//Buckets

	Bucket: 'buckets',

	// auto investment

	AutoInvestment: 'auto-investment',

	//Report

	Reports: 'reports',
	ReportInvestorSignUp: 'investor-signup',
	ReportLoanTape: 'loan-tape',
	ReportBorrowerSignUp: 'borrowers-signup',
	ReportApprovedInvestor: 'approved-investors',
	ReportBorrowerShareholders: 'borrower-shareholders',
	ReportInvestorsDeposit: 'investor-deposits',
	ReportInvestorsWithdrawal: 'investor-withdrawals',
	ReportAECB: 'aecb',
	ReportCorporateInvestorShareholder: 'corporate-investor-shareholders',
	ReportCRSData: 'crs-data-report',
	ReportPromoCode: 'promo-code-report',
	ReportInvestorAcquisitionChannels: 'investor-acquisition-channels',
	ReportMarketing: 'marketing',
	ReportDFSA: 'dfsa-report',
	ReportDFSAOpportunities: "dfsa-investor-opportunities",
	ReportUserSurvey: 'user-survey',
	ReportInvestorDailyBalances: 'investor-daily-balances',

	//Authentication

	Login: 'login',
	ForgotPassword: 'forgot-password',
	ResetPassword: 'reset-password',
	Unauthorized: 'restricted-page',
};
